"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _planHelper = require("../../util/planHelper");
var _Button = _interopRequireDefault(require("../Button"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _paymentSlice = require("../../redux/paymentSlice");
var _store = require("../../redux/store");
var _offerSlice = require("../../redux/offerSlice");
var _FreeOfferStyled = require("./FreeOfferStyled");
var _jsxRuntime = require("react/jsx-runtime");
const FreeOffer = _ref => {
  let {
    onPaymentComplete
  } = _ref;
  const {
    loading: isLoading,
    error
  } = (0, _store.useAppSelector)(_paymentSlice.selectPayment);
  const {
    period,
    expiresAt,
    startTime,
    offerTitle,
    offerId
  } = (0, _store.useAppSelector)(_offerSlice.selectOnlyOffer);
  const dispatch = (0, _store.useAppDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const offerType = offerId === null || offerId === void 0 ? void 0 : offerId.charAt(0);
  const icon = period || offerType;
  const generateDescriptionForFreeOffer = () => {
    switch (offerType) {
      case 'S':
        {
          return t('free-offer.subscription', 'Free subscription');
        }
      case 'P':
        {
          if (!period) {
            return t('free-offer.pass', 'Access until {{date}}', {
              date: (0, _planHelper.dateFormat)(expiresAt, true)
            });
          }
          return "".concat(t("period.".concat(period), _planHelper.periodMapper[period].accessText), " ").concat(t('free-offer.free-pass', 'free pass'));
        }
      case 'E':
        {
          return t('free-offer.event', 'Free event {{date}}', {
            date: startTime ? (0, _planHelper.dateFormat)(startTime, true) : ''
          });
        }
      case 'R':
        {
          return "".concat(t("period.".concat(period), _planHelper.periodMapper[period].accessText), " ").concat(t('free-offer.free-access', 'free access'));
        }
      case 'A':
        return t('free-offer.unlimited-access', 'Unlimited access');
      default:
        return '';
    }
  };
  const getAccessToFreeOffer = (0, _react.useCallback)(() => {
    dispatch((0, _paymentSlice.submitPaymentWithoutDetails)()).unwrap().then(onPaymentComplete);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeOfferStyled.WrapStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FreeOfferStyled.CardStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeOfferStyled.SubscriptionIconStyled, {
        icon: icon
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeOfferStyled.TitleStyled, {
        children: t("offer-title-".concat(offerId), offerTitle)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeOfferStyled.DescriptionStyled, {
        children: generateDescriptionForFreeOffer()
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FreeOfferStyled.ButtonWrapperStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          width: "200px",
          onClickFn: getAccessToFreeOffer,
          disabled: isLoading,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
              buttonLoader: true,
              color: "#ffffff"
            }) : t('free-offer.get-access', 'Get Access')
          })
        }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeOfferStyled.ErrorMessageStyled, {
          children: t(error.translationKey, error.message)
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeOfferStyled.SubTextStyled, {
        children: t('free-offer.no-cost', 'Free, no additional cost')
      })]
    })
  });
};
var _default = exports.default = FreeOffer;